import type { NavApi } from "../../shell/router";
import { T } from "@v0y4ge/jrni-ui";
import { useT, t as i18nT } from "../../lib/i18n";

/**
 * Tickets section navigation. Tickets is a tab under the Events rail — the
 * ticket screens render the shared eventsSectionTabs (Tickets active) as their
 * PRIMARY nav, then this secondary subtab row for Ticket Types · Ticket Groups.
 */
export function ticketsTabs(nav: NavApi, typesCount: number, groupsCount: number) {
  return [
    { id: "types",  label: i18nT("tickets.subtabs.ticketTypes", "Ticket Types"),  count: typesCount,  onClick: () => nav.go("ticket-types") },
    { id: "groups", label: i18nT("tickets.subtabs.ticketGroups", "Ticket Groups"), count: groupsCount, onClick: () => nav.go("ticket-groups") },
  ];
}

/** Secondary subtab row shown beneath the primary Events tabs on ticket screens. */
export function TicketsSubTabs({ nav, active, typesCount, groupsCount }: { nav: NavApi; active: "types" | "groups"; typesCount: number; groupsCount: number }) {
  const t = useT();
  const tabs = ticketsTabs(nav, typesCount, groupsCount);
  return (
    <div role="tablist" aria-label={t("tickets.subtabs.ticketsSubsections", "Tickets subsections")} style={{ display: "flex", gap: 8, padding: "12px 24px 0", background: T.canvas, flexShrink: 0 }}>
      {tabs.map((t) => {
        const on = t.id === active;
        return (
          <button key={t.id} role="tab" aria-selected={on} onClick={t.onClick} style={{
            display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", borderRadius: 999,
            fontSize: 13, fontWeight: 600, fontFamily: T.font, cursor: "pointer",
            background: on ? T.p1 : T.white, color: on ? T.white : T.n1,
            border: `1px solid ${on ? T.p1 : T.borderStrong}`,
          }}>
            {t.label}
            {typeof t.count === "number" ? <span style={{ fontSize: 11, fontWeight: 700, padding: "1px 7px", borderRadius: 999, background: on ? "rgba(255,255,255,0.25)" : T.n6, color: on ? T.white : T.soft }}>{t.count}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
